(() => {
  'use strict';
const productDetails={
  business:{
    title:'Business Clarity Worksheet',path:'/collections/all',
    description:'For freelance video editors who want a clearer answer to who they serve, what kind of work they want more of and what direction they are building toward.',
    when:'Your positioning feels vague, your client mix feels random or you need to decide what kind of editing business you actually want.',
    outcome:'A clearer ideal customer, a sharper value proposition and a one-sentence direction for the next 6–12 months.',
    questions:['Who do you want to edit for?','What problem are they hiring an editor to solve?','What do you want to be known for?'],plate:['Business','Clarity'],
    pages:[{image:'',label:'Who you want to serve',width:980,height:1720},{image:'',label:'What you are building',width:935,height:1351}],
    exampleTitle:'A clearer picture of your editing business.',
    fields:[
      {question:'Who do you want to edit for?',answers:['Educational YouTube creators with a weekly video essay series.']},
      {question:'What problem are they hiring an editor to solve?',answers:['Turn long recordings into clear stories and free up their time to create.']}
    ],
    resultLabel:'What do you want to be known for?',result:'Reliable, story-led edits that keep the creator’s voice.'
  },
  daily:{
    title:'Daily Priorities Worksheet',path:'/collections/all',
    description:'For busy freelance video editors balancing multiple clients, deadlines and requests who need to decide what actually deserves their attention today.',
    when:'Everything feels important, several clients need something and your day risks becoming a reaction to whoever is loudest.',
    outcome:'Three priorities in order, a clearer reason for each choice and one explicit commitment about what you will not let distract you.',
    questions:['What are the three most important outcomes for today?','Is this genuinely time-sensitive, or did someone else make it feel urgent?','What are you officially giving yourself permission not to do today?'],plate:['Daily','Priorities'],
    pages:[{image:'',label:'Choose your priorities',width:980,height:1268},{image:'',label:'Defend your choices',width:935,height:1210}],
    exampleTitle:'A full inbox. A clearer plan.',
    fields:[
      {question:'What are the three most important outcomes for today?',answers:['Deliver the creator’s first cut by 4 p.m.','Send the agreed client revisions.','Confirm the scope of the next edit.'],ordered:true},
      {question:'Is this genuinely time-sensitive, or did someone else make it feel urgent?',answers:['The first-cut deadline is real. The thumbnail change can wait for the next review.']}
    ],
    resultLabel:'What is one thing you are officially giving yourself permission not to do today?',result:'Rework my portfolio or check notifications between every cut.'
  }
};

  try {
    const storeData=JSON.parse(document.getElementById('take1-store-data')?.textContent || '{}');
    Object.keys(productDetails).forEach(key=>Object.assign(productDetails[key], storeData[key] || {}));
  } catch(error) { console.error('TAKE1 product data could not be loaded.', error); }
function questionItems(questions){return questions.map(text=>{const li=document.createElement('li');li.textContent=text;return li;});}
function exampleFields(detail,filled=true){
  return detail.fields.map(field=>{
    const box=document.createElement('div');box.className='example-field';
    const question=document.createElement('p');question.className='example-question';question.textContent=field.question;box.append(question);
    if(filled){
      if(field.ordered){const list=document.createElement('ol');list.className='example-answer example-priorities';list.append(...questionItems(field.answers));box.append(list);}
      else{const answer=document.createElement('p');answer.className='example-answer';answer.textContent=field.answers.join(' ');box.append(answer);}
    }else{
      const lines=document.createElement('div');lines.className='example-empty';lines.setAttribute('aria-label','Blank answer space');
      for(let i=0;i<(field.ordered?3:2);i++)lines.append(document.createElement('span'));
      box.append(lines);
    }
    return box;
  });
}
function bindTabs(tabs,select){
  tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>select(tab));
    tab.addEventListener('keydown',event=>{
      let next;
      if(event.key==='ArrowRight')next=(index+1)%tabs.length;
      else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
      else if(event.key==='Home')next=0;
      else if(event.key==='End')next=tabs.length-1;
      else return;
      event.preventDefault();select(tabs[next]);tabs[next].focus();
    });
  });
}
function selectTab(tabs,tab,panel){
  tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;});
  panel.setAttribute('aria-labelledby',tab.id);
}

  function initialize() {
    const menuButton=document.querySelector('.menu-button');
    const navigation=document.querySelector('#navigation');
    if(menuButton && navigation && !menuButton.dataset.bound){
      menuButton.dataset.bound='true';
      menuButton.addEventListener('click',()=>{
        const open=menuButton.getAttribute('aria-expanded')==='true';
        menuButton.setAttribute('aria-expanded',String(!open));
        menuButton.setAttribute('aria-label',open?'Open navigation':'Close navigation');
        navigation.classList.toggle('is-open',!open);
      });
      navigation.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{
        menuButton.setAttribute('aria-expanded','false');menuButton.setAttribute('aria-label','Open navigation');navigation.classList.remove('is-open');
      }));
    }
    const revealButton=document.querySelector('#reveal-button');
    const packageFrame=document.querySelector('#package-frame');
    const insidePanel=document.querySelector('#inside-panel');
    if(revealButton && packageFrame && insidePanel && !revealButton.dataset.bound){
      revealButton.dataset.bound='true';
      revealButton.addEventListener('click',()=>{
        const open=revealButton.getAttribute('aria-expanded')==='true';
        revealButton.setAttribute('aria-expanded',String(!open));insidePanel.hidden=open;
        packageFrame.classList.toggle('is-open',!open);
        revealButton.querySelector('span').textContent=open?'See what’s inside':'Back to slideshow';
        packageFrame.dispatchEvent(new CustomEvent('take1:preview-toggle',{detail:{open:!open}}));
      });
    }
    const worksheetTabs=Array.from(document.querySelectorAll('[role="tab"][data-worksheet]'));
    const worksheetPanel=document.querySelector('#worksheet-panel');
    const worksheetCta=document.querySelector('#worksheet-cta');
    if(worksheetTabs.length && worksheetPanel && !worksheetPanel.dataset.bound){
      worksheetPanel.dataset.bound='true';
function selectWorksheet(tab){
  const key=tab.dataset.worksheet;const detail=productDetails[key];selectTab(worksheetTabs,tab,worksheetPanel);
  document.querySelector('#worksheet-title').textContent=detail.title;
  document.querySelector('#worksheet-price').textContent=detail.price;
  document.querySelector('#worksheet-description').textContent=detail.description;
  document.querySelector('#worksheet-when').textContent=detail.when;document.querySelector('#worksheet-outcome').textContent=detail.outcome;
  document.querySelector('#worksheet-questions').replaceChildren(...questionItems(detail.questions));
  worksheetCta.textContent=`See the ${detail.title} in action`;worksheetCta.href=detail.path;
  document.querySelector('#worksheet-plate-name').replaceChildren(document.createTextNode(detail.plate[0]),document.createElement('br'),document.createTextNode(detail.plate[1]));
  document.querySelector('#worksheet-example .example-kicker').textContent=detail.title.toUpperCase();
  document.querySelector('#worksheet-example-title').textContent=detail.exampleTitle;
  document.querySelector('#worksheet-example-fields').replaceChildren(...exampleFields(detail));
  document.querySelector('#worksheet-result-label').textContent=detail.resultLabel.toUpperCase();document.querySelector('#worksheet-result').textContent=detail.result;
  document.querySelector('#worksheet-visual').dataset.active=key;
}

      bindTabs(worksheetTabs,selectWorksheet);
      selectWorksheet(worksheetTabs.find(tab=>tab.getAttribute('aria-selected')==='true') || worksheetTabs[0]);
    }
    const exampleTabs=Array.from(document.querySelectorAll('[data-example-view]'));
    const examplePanel=document.querySelector('#product-example-panel');
    const kind=document.querySelector('[data-take1-product]')?.dataset.take1Product;
    const detail=productDetails[kind];
    if(exampleTabs.length && examplePanel && detail && !examplePanel.dataset.bound){
      examplePanel.dataset.bound='true';
      const selectExample=tab=>{
        const filled=tab.dataset.exampleView==='filled';selectTab(exampleTabs,tab,examplePanel);
        document.querySelector('#product-example-fields').replaceChildren(...exampleFields(detail,filled));
        const result=document.querySelector('#product-example-result');result.textContent=filled?detail.result:'Your answer goes here.';result.classList.toggle('is-empty',!filled);
        document.querySelector('#product-example-status').textContent=filled?'Illustrative answers from a freelance editor':'A few of the questions you will work through';
      };
      bindTabs(exampleTabs,selectExample);
    }
  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);

  const dialog=document.querySelector('#product-dialog');
  if(!dialog) return;
  let lastPreviewButton=null;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-preview]');
    if(!button) return;
    const id=button.dataset.preview, detail=productDetails[id];
    if(!detail) return;
    lastPreviewButton=button;
    document.querySelector('#dialog-code').textContent='2-PAGE PRINTABLE PDF · '+(detail.price || '');
    document.querySelector('#dialog-title').textContent=detail.title;
    document.querySelector('#dialog-description').textContent=detail.description;
    const previews=detail.pages.map(page=>{
      const figure=document.createElement('figure');figure.className='dialog-worksheet-page';
      const label=document.createElement('figcaption');label.className='mono';label.textContent=page.label;
      const preview=document.createElement('div');preview.className=`worksheet-paper worksheet-paper-${id}`;
      const image=document.createElement('img');image.src=page.image;image.alt=`${detail.title}: ${page.label}`;image.width=page.width;image.height=page.height;
      preview.append(image);figure.append(label,preview);return figure;
    });
    document.querySelector('#dialog-preview').replaceChildren(...previews);
    document.querySelector('#dialog-includes').replaceChildren(...questionItems(detail.questions));
    document.querySelector('#dialog-product-link').href=detail.path;
    dialog.showModal();document.body.classList.add('dialog-open');
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const r=dialog.getBoundingClientRect();
    if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)dialog.close();
  });
  dialog.addEventListener('close',()=>{document.body.classList.remove('dialog-open');lastPreviewButton?.focus();});
})();
